import { useTranslate } from "@tolgee/react";
import { Plus } from "lucide-react";
import { Button } from "#/components/ui/button";
import { useDeposit } from "#/hooks/use-trading-actions";
import { cn } from "#/lib/utils";
import { DepositDialog } from "./deposit-dialog.tsx";
import { DepositWarningIndicator } from "./deposit-warning-indicator.tsx";

type OrderAccountSummaryProps = {
	availableFunds: string;
	currentPositionLabel: string;
};

export function OrderAccountSummary({
	availableFunds,
	currentPositionLabel,
}: OrderAccountSummaryProps) {
	const { t } = useTranslate();
	const deposit = useDeposit();

	return (
		<div className="flex flex-col gap-0.5 sm:gap-1 sm:pt-1">
			<div className="flex items-center justify-between gap-3 text-caption1 text-trade-text-secondary sm:text-label2">
				<span>{t("form.available-funds")}</span>
				<DepositDialog onConfirm={(amount) => deposit.mutateAsync(amount)}>
					<Button
						variant="ghost"
						size="xs"
						className={cn(
							"h-auto p-0 text-trade-text hover:text-primary hover:bg-transparent",
							"gap-0.5 [&_svg]:size-3 sm:[&_svg]:size-3.5",
						)}
						aria-label="Deposit funds"
					>
						<DepositWarningIndicator className="h-3 w-3 sm:h-3.5 sm:w-3.5 mr-0.5" />
						<span>{availableFunds}</span>
						<Plus className="h-3 w-3 sm:h-3.5 sm:w-3.5" />
					</Button>
				</DepositDialog>
			</div>
			<div className="flex items-center justify-between gap-3 text-caption1 text-trade-text-secondary sm:text-label2">
				<span>{t("form.current-position")}</span>
				<span className="text-trade-text">{currentPositionLabel}</span>
			</div>
		</div>
	);
}
